import NiceModal, { useModal } from '@ebay/nice-modal-react';

// Import types
import type { TValues, TKey } from 'types/libraries/i18n';

export type AntModalProps = {
	title: TKey;
	description?: { key: TKey; values?: TValues };
	context?: string;
	confirmText?: TKey | null;
	cancelText?: TKey | null;
	onConfirm?: () => void;
	onCancel?: () => void;
	namespace?: string;
	closable?: boolean;
};

// Import components
import { AntModal } from './AntModal';

export const AntNiceModal = NiceModal.create(({ onConfirm, onCancel, ...props }: AntModalProps) => {
	const { visible, remove } = useModal();

	const handleConfirm = () => {
		onConfirm?.();
		remove();
	};

	const handleCancel = () => {
		onCancel?.();
		remove();
	};

	return <AntModal {...props} visible={visible} onConfirm={handleConfirm} onCancel={handleCancel} closeModal={remove} />;
});
